var map = {
	"./english/export_translations": "./assets/language/english/export_translations.js",
	"./portuguese-brazilian/export_translations": "./assets/language/portuguese-brazilian/export_translations.js",
	"./spanish/export_translations": "./assets/language/spanish/export_translations.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/language sync recursive ^\\.\\/.*\\/export_translations$";